import type { ComponentProps } from "react"
import { RadioGroup, RadioGroupItem } from "../components/ui/radio-group"
import {
  Field,
  FieldDescription,
  FieldError,
  FieldLabel,
  FieldLegend,
  FieldSet,
} from "@holigral/shared/ui/components/ui/field"

type Props = Omit<ComponentProps<typeof RadioGroup>, "onChange"> & {
  label?: string
  onChange: (value: string) => void
  options: {
    label: string
    value: string
  }[]
  helperText?: string
  error?: string | null
}

export default function RadioGroupField({
  label,
  onChange,
  options,
  helperText,
  error,
  ...props
}: Props) {
  return (
    <FieldSet>
      {label && <FieldLegend variant="label">{label}</FieldLegend>}
      {helperText && <FieldDescription>{helperText}</FieldDescription>}
      <RadioGroup
        onValueChange={(value) => {
          onChange(value as string)
        }}
        {...props}
      >
        {options.map(({ value, label }) => (
          <Field key={value} orientation="horizontal">
            <RadioGroupItem value={value} id={value} />
            <FieldLabel htmlFor={value} className="font-normal">
              {label}
            </FieldLabel>
          </Field>
        ))}
      </RadioGroup>
      <FieldError>{error}</FieldError>
    </FieldSet>
  )
}
